import eventMemberApi from "modules/eventMemberList/eventMember.api";
import * as yup from "yup";

export enum Errors {
  USER_NOT_INVITED = "user-not-invited",
}

const hasUserBeenInvited = yup
  .string()
  .required()
  .email()
  .test("user-invited", Errors.USER_NOT_INVITED, async (email, context) => {
    if (!email) {
      return false;
    }
    if (!context.options.context?.event.isPrivate) {
      return true;
    }
    const { isSuccess, data } = await eventMemberApi.checkEmailInvited(
      context.options.context?.event.id,
      email,
    );

    return isSuccess && data.invited;
  });

export const emailSchema = yup.object({
  email: hasUserBeenInvited,
});

export const getEmailErrorMessage = (error: unknown) => {
  if (!(error instanceof yup.ValidationError)) {
    return "eventLanding:enter.valid.email";
  }
  switch (error.message) {
    case Errors.USER_NOT_INVITED: {
      return "eventLanding:absent.email.invitation.list";
    }
    default: {
      return "eventLanding:enter.valid.email";
    }
  }
};
